import * as Immutable from 'immutable';
import { createMigration } from './utils';
import {
    targetTextPositionPreset1bLandscape,
    targetTextPositionPreset1bSquare,
    targetTextPositionPreset1bVertical,
    targetTextPositionPreset2bLandscape,
    targetTextPositionPreset2bSquare,
    targetTextPositionPreset2bVertical,
    targetTextPositionPreset3bLandscape,
    targetTextPositionPreset3bSquare,
    targetTextPositionPreset3bVertical
} from './resources/multiMediaSceneTextPositionPreset';

function getAspectRatioForResolution(width: number, height: number) {
    if (width === 1920 && height === 1080) {
        return 'landscape';
    }
    if (width === 1080 && height === 1920) {
        return 'vertical';
    }
    if (width === 1080 && height === 1080) {
        return 'square';
    }
    throw new Error(`Unknown width/height: ${width}/${height}`);
}

function mergeTextPositionPresets(textPositionPreset, normalStyle, highlightStyle) {
    return Immutable.fromJS(Object.fromEntries(Object.entries(textPositionPreset).map(([position, config]) => [position, [
        {
            ...config[0],
            normalStyle: {
                objectAnimation: normalStyle.get('objectAnimation'),
                colorGraphics: normalStyle.get('colorGraphics'),
                alphaGraphics: normalStyle.get('alphaGraphics'),
            },
            highlightStyle: {
                objectAnimation: highlightStyle.get('objectAnimation'),
                colorGraphics: highlightStyle.get('colorGraphics'),
                alphaGraphics: highlightStyle.get('alphaGraphics'),
            },
        },
    ]])));
}

export const migrationTo9_164 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene) {
        return scene.withMutations(map => {
            const sceneDesignName = scene.get('sceneDesign');
            const width = scene.getIn(['resolution', 'width']) as number;
            const height = scene.getIn(['resolution', 'height']) as number;
            const aspectRatio = getAspectRatioForResolution(width, height);

            // return if it's not any of the selected multi media scenes
            if (!sceneDesignName.includes('MultipleMedia1b') && !sceneDesignName.includes('MultipleMedia2b') && !sceneDesignName.includes('MultipleMedia3b')) {
                return;
            }
            if ([
                'best_western_1:MultipleMedia1b_v2',
                'best_western_1:MultipleMedia2b_v2',
                'best_western_1:MultipleMedia3b_v2',
                'robert_half:MultipleMedia1b',
                'robert_half:MultipleMedia2b',
                'robert_half:MultipleMedia3b',
            ].includes(sceneDesignName)) {
                return;
            }

            // skip scenes that have more than one text asset
            var count = 0;
            let textAsset = null;
            scene.get('subslides', []).forEach((subslide, s) => {
                subslide.get('children', []).forEach((child, c) => {
                    const path = ['subslides', s, 'children', c];
                    const asset = scene.getIn(path) as Immutable.Map<string, any>;
                    if (asset && asset.get('classType') === 'GraphicStyleTextAsset') {
                        count++;
                        textAsset = asset;
                    }
                });
            });
            if (count > 1) {
                return;
            }

            const normalStyle = textAsset.get('normalStyle');
            const highlightStyle = textAsset.get('highlightStyle');

            // apply new text position presets
            if (aspectRatio === 'landscape' && sceneDesignName.includes('MultipleMedia1b')) {
                map.set('textPositionPresets', mergeTextPositionPresets(targetTextPositionPreset1bLandscape, normalStyle, highlightStyle));
            }
            else if (aspectRatio === 'square' && sceneDesignName.includes('MultipleMedia1b')) {
                map.set('textPositionPresets', mergeTextPositionPresets(targetTextPositionPreset1bSquare, normalStyle, highlightStyle));
            }
            else if (aspectRatio === 'vertical' && sceneDesignName.includes('MultipleMedia1b')) {
                map.set('textPositionPresets', mergeTextPositionPresets(targetTextPositionPreset1bVertical, normalStyle, highlightStyle));
            }
            else if (aspectRatio === 'landscape' && sceneDesignName.includes('MultipleMedia2b')) {
                map.set('textPositionPresets', mergeTextPositionPresets(targetTextPositionPreset2bLandscape, normalStyle, highlightStyle));
            }
            else if (aspectRatio === 'square' && sceneDesignName.includes('MultipleMedia2b')) {
                map.set('textPositionPresets', mergeTextPositionPresets(targetTextPositionPreset2bSquare, normalStyle, highlightStyle));
            }
            else if (aspectRatio === 'vertical' && sceneDesignName.includes('MultipleMedia2b')) {
                map.set('textPositionPresets', mergeTextPositionPresets(targetTextPositionPreset2bVertical, normalStyle, highlightStyle));
            }
            else if (aspectRatio === 'landscape' && sceneDesignName.includes('MultipleMedia3b')) {
                map.set('textPositionPresets', mergeTextPositionPresets(targetTextPositionPreset3bLandscape, normalStyle, highlightStyle));
            }
            else if (aspectRatio === 'square' && sceneDesignName.includes('MultipleMedia3b')) {
                map.set('textPositionPresets', mergeTextPositionPresets(targetTextPositionPreset3bSquare, normalStyle, highlightStyle));
            }
            else if (aspectRatio === 'vertical' && sceneDesignName.includes('MultipleMedia3b')) {
                map.set('textPositionPresets', mergeTextPositionPresets(targetTextPositionPreset3bVertical, normalStyle, highlightStyle));
            }
        });
    },
});
